<template lang="pug">
.modal.fade(tabindex="-1", role="dialog", :id="id")
    .modal-dialog(role="document")
        .modal-content
            .modal-header(v-if="!hideFooter")
                slot(name="header")
                h5.modal-title
                    slot(name="title")

            .modal-body
                slot(name="body")

            .modal-footer(v-if="!hideFooter")
                button.btn.btn-fw.white(
                    :disabled="loading",
                    data-dismiss="modal"
                ) {{ cancelText }}

                slot(name="footer")
</template>

<script>
export default {
    props: {
        id: {
            type: String,
            default: 'centerModal',
        },

        width: {
            type: String,
            default: 'w-xxl',
        },

        cancelText: {
            type: String,
            default: 'Close',
        },

        loading: {
            type: Boolean,
            default: false,
        },

        hideHeader: {
            type: Boolean,
            default: false,
        },

        hideFooter: {
            type: Boolean,
            default: false,
        },

        backdrop: {
            type: Boolean,
            default: true,
        },

        keyboard: {
            type: Boolean,
            default: true,
        },
    },

    mounted() {
        this.$on('show', () => {
            const options = {
                backdrop: this.backdrop || 'static',
                keyboard: this.keyboard,
                show: true,
            };

            $(`#${this.id}`).modal(options);
        });

        this.$on('hide', () => $(`#${this.id}`).modal('hide'));
    },
};
</script>
